




































import { Mixins, Component } from "vue-property-decorator";
import { HisInformationSetting } from "../../../../../../../base/domain/his";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { HisInformationItemSelector } from "../selectors";

@Component({
  components: {
    hisInformationItemSelector: HisInformationItemSelector,
  }
})
export default class HisInformationItemSelectDialog extends Mixins(DialogMixin) {
  data() {
    return {
      selectedItem: null as HisInformationSetting,
      confirmSelected: false,
      tableData: [] as HisInformationSetting[],
    };
  }
  selectedItem: HisInformationSetting;
  confirmSelected: boolean;
  tableData: HisInformationSetting[];

  $refs!: {
    itemSelector: HisInformationItemSelector,
  };

  async show(data: HisInformationSetting[], selected: HisInformationSetting): Promise<HisInformationSetting> {
    return this.showModal(async () => {
      this.tableData = data;
      this.selectedItem = null;
      this.confirmSelected = false;
      await this.$nextTick();
      if (this.$refs.itemSelector) {
        this.$refs.itemSelector.changeSelection(selected);
      }
      await this.waitHidden();
      return this.confirmSelected ? this.selectedItem : null;
    });
  }

  get isSelected(): boolean {
    return !!this.selectedItem;
  }

  updateSelectedHisInformationItem(value: HisInformationSetting) {
    this.selectedItem = value;
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }
}
